module.exports = __webpack_public_path__ + "static/media/logo.0859d985.svg";